import React, { useState } from 'react';
import QuestionWrapper from '../../../wrappers/question_wrapper/index';

import styles from '../questionnaire.module.css';

export default function TextInput({
  onBack,
  onSubmit,
  title,
  para,
  keyForAnswer,
  answers,
  placeholder,
  optional,
  placeholderFontSize,
}) {
  const [text, setText] = useState((answers && answers[keyForAnswer]) || '');

  const submit = (e) => {
    e.preventDefault();
    let newText = { [keyForAnswer]: text };
    onSubmit(newText);
  };

  const handleChange = (event) => {
    setText(event.target.value);
  };

  return (
    <QuestionWrapper onSubmit={submit} onBack={onBack} isDisabled={!optional && text.trim().length === 0}>
      <h5 className={styles.question}>{title}</h5>
      <p className={styles.question_para}>{para}</p>
      <div className={`${styles.tile} material-input light ${styles.marg_center}`}>
        <input
          placeholder={placeholder}
          type='text'
          name='text'
          value={text}
          onChange={handleChange}
          style={placeholderFontSize ? { '--placeholder-font-size': placeholderFontSize } : undefined}
          className={placeholderFontSize ? styles.custom_placeholder : undefined}
        />
      </div>
    </QuestionWrapper>
  );
}
